module.exports = __webpack_public_path__ + "img/loading.9bbb48a8.gif";